var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXerror(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0138 10.2454L23.3101 8.54163L16.5555 15.2962L9.80092 8.54163L8.09717 10.2454L14.8518 17L8.09717 23.7545L9.80092 25.4583L16.5555 18.7037L23.3101 25.4583L25.0138 23.7545L18.2593 17L25.0138 10.2454Z",
    fill: "#717171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXerror);
export default __webpack_public_path__ + "static/media/xerror.4e087db1a23e08a4b847f92bce19ad54.svg";
export { ForwardRef as ReactComponent };